import React, {useState, useEffect, useCallback} from 'react';
import {Modal} from "../../../utils/modal/Modal";
import {useDispatch} from "react-redux";
import {toast} from "react-toastify";
import {formatErrors} from "../../../constants";
import {getcourseDataAction} from "../../../actions/getcourseDataAction";
import {dichatLinkPurchaseAction} from "../../../actions/clientAction";
import {Loader} from "../../../utils/loader/Loader";
import {ConfirmModal} from "../../../utils/confirm/ConfirmModal";

// «Привязать покупку к этому номеру».
//
// Клиентка вошла с номера, по которому покупки нет, и оставила обращение с
// номером/почтой, на которые покупала. Специалист заботы ищет этот заказ в
// выгрузке getcourse (поиск заранее заполнен телефоном клиентки — но искать
// нужно как раз по тем данным, что она указала) и привязывает найденный заказ к
// её текущему номеру. Дальше бэкенд дозачисляет, гасит обращение и будит
// приложение.
export function ClientLinkPurchaseModal({clientId, clientPhone, trigger, handleComplete}) {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState('');
  const [items, setItems] = useState([]);
  const [searched, setSearched] = useState(false);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const handleOpen = (value) => {
    if (loading) {
      return;
    }
    setOpen(value);
  };

  useEffect(() => {
    if (open) {
      setSearch(clientPhone || '');
      setItems([]);
      setSearched(false);
    }
  }, [open, clientPhone]);

  const handleSearch = useCallback(() => {
    if (loading || search.trim() === '') {
      return;
    }
    setLoading(true);
    dispatch(getcourseDataAction({
      page: 1, limit: 10, search: search.trim(), sort: 'email', sortd: 'asc', curator_id: '', course: 0,
    })).then((data) => {
      setItems(data.items || []);
      setSearched(true);
      setLoading(false);
    }).catch((e) => {
      setLoading(false);
      toast.error(formatErrors([e.message]), {position: toast.POSITION.BOTTOM_RIGHT});
    });
  }, [dispatch, loading, search]);

  const handleLink = (uid) => {
    return new Promise((resolve) => {
      if (loading) {
        return resolve(false);
      }
      setLoading(true);
      dispatch(dichatLinkPurchaseAction(clientId, uid)).then(() => {
        setLoading(false);
        setOpen(false);
        toast.success('Покупка привязана к номеру клиентки', {position: toast.POSITION.BOTTOM_RIGHT});
        resolve(true);
        if (typeof handleComplete === 'function') {
          handleComplete();
        }
      }).catch((e) => {
        setLoading(false);
        resolve(false);
        toast.error(formatErrors([e.message]), {position: toast.POSITION.BOTTOM_RIGHT});
      });
    });
  };

  return <Modal isStatic={true} isWide={true} open={open} handleOpen={handleOpen} trigger={trigger} triggerWrap={false}>
    <React.Fragment>
      <div className="modal__title">Привязать покупку к этому номеру</div>
      <div className="modal__wrap">
        <div className="link-purchase__search">
          <input
            className="input__control"
            type="text"
            value={search}
            placeholder="Телефон или email из обращения"
            disabled={loading}
            onChange={(e) => setSearch(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                handleSearch();
              }
            }}
          />
          <button className="btn btn--primary" disabled={loading} onClick={handleSearch}>Найти заказ</button>
        </div>

        {loading && <Loader size="large" padded={true}/>}

        {!loading && searched && items.length === 0 &&
          <div className="link-purchase__empty">Заказов не найдено. Проверьте номер или email из обращения.</div>}

        {!loading && items.length > 0 && <div className="link-purchase__list">
          {items.map((i) => <div key={i.id} className="link-purchase__item">
            <div className="link-purchase__info">
              <span className="link-purchase__name">{i.last_name} {i.first_name}</span>
              <span className="link-purchase__product">{i.product_title || '—'}</span>
              <span className="link-purchase__contacts">{i.phone} · {i.email}</span>
            </div>
            <ConfirmModal
              trigger={<button className="btn btn--primary" disabled={loading}>Привязать</button>}
              triggerWrap={false}
              title={'Привязать эту покупку к номеру ' + (clientPhone || 'клиентки') + '?'}
              handleOk={() => handleLink(i.uid)}
            />
          </div>)}
        </div>}
      </div>
    </React.Fragment>
  </Modal>;
}
